/**
 * In-memory GET response cache with TTL.
 * Reduces redundant API calls when navigating between pages (e.g. /schools, leaderboard).
 */

const cache = new Map();

const defaultTtlMs = 5 * 60 * 1000; // 5 minutes

function getCacheKey(url, params = {}) {
  const paramStr = typeof params === 'object' && params !== null
    ? JSON.stringify(params)
    : '';
  return url + (paramStr ? `?${paramStr}` : '');
}

export function getCachedValue(key) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expires) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function setCachedValue(key, data, ttlMs = defaultTtlMs) {
  cache.set(key, {
    data,
    expires: Date.now() + ttlMs,
  });
}

export function getCacheKeyForRequest(url, params) {
  return getCacheKey(url, params);
}

export function invalidateKey(key) {
  cache.delete(key);
}

export function invalidatePattern(pattern) {
  if (typeof pattern === 'string' && !pattern.includes('*')) {
    cache.delete(pattern);
    return;
  }
  const regex = pattern instanceof RegExp ? pattern : new RegExp('^' + pattern.replace(/\*/g, '.*') + '$');
  for (const key of cache.keys()) {
    if (regex.test(key)) cache.delete(key);
  }
}

export default {
  get: getCachedValue,
  set: setCachedValue,
  getKey: getCacheKeyForRequest,
  invalidate: invalidateKey,
  invalidatePattern,
};
